import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from "../guards/auth.guard";
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import {VisitorsComponent} from "./visitors.component";

const routes: Routes = [
  {
    path: 'visitors',
    component: VisitorsComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.VISITORS }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VisitorsRoutingModule { }
